import React from 'react';
import Tab from 'src/ui/library/Tab';

export default function AppUpdateTabPres(props) {
  const { children, handleChangeTabType, activeTab } = props;
  const labels = ['Android', 'IOS'];

  return (
    <div>
      <header className="">
        <Tab labels={labels} styleType="primary" defaultValue={activeTab} handleChangeStatus={handleChangeTabType}>
          {children}
        </Tab>
      </header>
    </div>
  );
}
